module.exports = __webpack_public_path__ + "img/farewell_7.d1efb7df.jpg";